/**
 * Imports here will be global across every final RCP file
 */

import '../../global_base_vendor_builder.js';

// Disabled
//import CarbonAds from '../../../../assets/js/Ads/CarbonAds.js';
//CarbonAds();

import Datadome from '../../../../assets/js/Analytics/Datadome.js';
Datadome();

import FacebookPixel from '../../../../assets/js/Analytics/FacebookPixel.js';
FacebookPixel();

import HotJar from '../../../../assets/js/Utility/HotJar';
HotJar();